import { t } from '@/libs/i18n';
import ApplicationController from '../application_controller';
import { confirmar } from '../../../../libs/cifra/dialogs';

/*
  Gestiona el formulario de edición de un curso de un servicio, mostrando avisos
  cuando se modifican las fechas de inicio o fin.
*/
export default class extends ApplicationController {
  connect() {
    this.avisos = {};
    this.element.addEventListener('submit', this.#onSubmit.bind(this));
    this.#conectarEventosFechas();
  }

  #conectarEventosFechas() {
    const fechaInput = this.element.querySelector('.fecha_inicio input');
    if (fechaInput) {
      fechaInput.addEventListener('change', () => {
        this.avisos.fecha_inicio = t('servicio_curso_avisos.modificacion_fecha_inicio');
      });
    }
    const fechaFinInput = this.element.querySelector('.fecha_fin input');
    if (fechaFinInput) {
      fechaFinInput.addEventListener('change', () => {
        this.avisos.fecha_fin = t('servicio_curso_avisos.modificacion_fecha_fin');
      });
    }
  }

  async #onSubmit(event) {
    // Si no hay confirmación, no hacemos nada
    if (this.textoConfirm === undefined) {
      return true;
    }

    event.preventDefault();
    const confirmado = await confirmar({
      text: this.textoConfirm,
      customClass: 'sweet-alert-2x',
    });
    if (confirmado) {
      this.element.submit();
    }
    return false;
  }

  get textoConfirm() {
    const avisos = Object.values(this.avisos);
    if (avisos.length > 0) {
      return `<div class="alert alert-warning text-left">${avisos.join('<br>')}</div>`;
    }
    return undefined;
  }
}
